import React from "react";

export default function LoginPage() {
  return (
    <div>
      <p>Login Page</p>
    </div>
  );
}
